import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-property-partners',
  templateUrl: './property-partners.component.html',
  styleUrls: ['./property-partners.component.scss']
})
export class PropertyPartnersComponent {
  partners: any = [
    { icon: 'zoopla.svg' },
    { icon: 'primelocation.svg', width: '120px' },
    { icon: 'rightmove.svg' },
  ]
}
